import { useMemo } from "react";
import { useRequests } from "./useRequests";
import { Request } from "../types/research.types";

export interface ChainedRequest extends Request {
  chained_request_objects: Request[];
}

export const useClassifiedRequests = (type: string) => {
  const { data: requests } = useRequests(type);

  const { simpleRequests, chainedRequests, requestMap } = useMemo(() => {
    const simple: Request[] = [];
    const chained: ChainedRequest[] = [];
    const map: Record<string, Request> = {};

    // First pass: create lookup map
    requests?.forEach((req) => {
      map[req.id] = req;
    });

    // Second pass: classify and populate chained objects
    requests?.forEach((req) => {
      if (req.chain_with && req.chain_with.length > 0) {
        const chainedReq: ChainedRequest = {
          ...req,
          chained_request_objects: req.chain_with
            .map((id) => map[id])
            .filter((r): r is Request => !!r),
        };
        chained.push(chainedReq);
      } else {
        simple.push(req);
      }
    });

    return { simpleRequests: simple, chainedRequests: chained, requestMap: map };
  }, [requests]);

  return {
    simpleRequests,
    chainedRequests,
    allRequests: requests || [],
    requestMap,
  };
};
